import { render, staticRenderFns } from "./assets.vue?vue&type=template&id=1240dd57&scoped=true&"
import script from "./assets.vue?vue&type=script&lang=js&"
export * from "./assets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240dd57",
  null
  
)

export default component.exports